export default __webpack_public_path__ + "static/media/CA-3 App overview.4a0020d5.png";